import { DataIndex } from '../types';

export function dataIndexToStringKey(dataIndex: DataIndex): string {
  if (Array.isArray(dataIndex)) {
    return dataIndex[dataIndex.length - 1];
  }
  return dataIndex;
}
